import { Fetch } from 'lib/Fetch';

export function validateOtp(receiver, otp) {
  return new Fetch('api_2')
    .url('/external/global/validate-otp')
    .method('POST')
    .data({ receiver, otp })
    .send();
}
